<template>
  <div class="pre-checkout-sidebar">
    <GenericModal
      ref="preCheckoutSidebarModal"
      :close-btn-color="'#231f20'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      :has-footer="false"
      :has-header="false"
      :max-width="'466px'"
      :extra-classes="'pre-checkout-inner-sidebar-body'"
      background-blur="none"
      border-radius="0px"
      unique-id="preCheckoutSidebarModal"
    >
    <div class="pre-checkout-sidebar-body">
      <div id="preCheckoutSideLogoBar">
        <a href="/">
          <img src="/ui/main/img/heals_logo_white_precheckout.png" title="Heals logo" alt="Heals logo" class="img-fluid aspect-img"
               width="383" height="152">
        </a>
        <span>Checkout</span>
      </div>
      <PreCheckoutSidebarLogin
        v-show="loginVisible"
        @register-click="onRegisterClick"
        @guest-click="onGuestClick"
      >
        <template v-slot:error>
          <div v-if="hasError" class="pre-checkout-sidebar-header">
            <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
          </div>
        </template>
      </PreCheckoutSidebarLogin>
      <PreCheckoutSidebarRegister
        v-show="registerVisible"
        @return-back-click="onReturnBackClick"
      >
        <template v-slot:error>
          <div v-if="hasError" class="pre-checkout-sidebar-header">
            <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
          </div>
        </template>
      </PreCheckoutSidebarRegister>
      <PreCheckoutSidebarGuest
        v-show="guestVisible"
        @return-back-click="onReturnBackClick"
      >
        <template v-slot:error>
          <div v-if="hasError" class="pre-checkout-sidebar-header">
            <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
          </div>
        </template>
      </PreCheckoutSidebarGuest>
    </div>
      <div class="minicart-product-list d-flex-100 pre-checkout-wrapper">
        <div class="return-button">
          <a href="/">
            {{ t("pre.checkout.return") }}
          </a>
        </div>
        <div class="col-12 checkout-form-header">
          <div class="checkout-form-title" @click="cartItemsToggle">
            <span class="checkout-form-title-text">
              {{ t("preview.order.cart.minicart.header") }}
            <span
              class="checkout-products-count"
              v-cloak
            >
              ({{ countCartProducts }})
            </span>
            </span>
            <img
              :src="cartItemsToggleImage"
              alt="cart items toggle"
              title="cart items toggle"
              loading="lazy"
              width="16"
              height="8"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="preCheckoutMiniCartContents" v-if="cartItemsVisible">
          <AdvCartProductList :mini-cart="true" :is-pre-checkout="true"></AdvCartProductList>
          <AdvCartGiftList :enable-minicart-picker="true" :mini-cart="true"></AdvCartGiftList>
        </div>
        <div class="cart-total-row">
          <div class="d-flex flex-wrap justify-content-between align-items-center total-item">
            <span>{{ t("checkout.final.sum") }}: </span>
            <div class="final-price">
              {{ cartProductsTotal.toFixed(2) }}
              <span v-html="selectedCurrency.symbol"></span>
            </div>
          </div>
        </div>
      </div>
  </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'
import PreCheckoutSidebarLogin from './PreCheckoutSidebarLogin.vue'
import PreCheckoutSidebarRegister from './PreCheckoutSidebarRegister.vue'
import PreCheckoutSidebarGuest from './PreCheckoutSidebarGuest.vue'
import AdvCartProductList from './AdvCartProductList.vue'
import AdvCartGiftList from './AdvCartGiftList.vue'
import store from '../../vue/store'
import { mapGetters } from 'vuex'

export default {
  name: 'PreCheckoutSidebar',
  data () {
    return {
      currentView: 'login', // Possible values: 'login', 'register', 'guest'
      currentViewError: '',
      cartItemsVisible: false
    }
  },
  props: {
    error: {
      type: String,
      default: ''
    }
  },
  components: {
    AdvCartGiftList,
    AdvCartProductList,
    GenericModal,
    PreCheckoutSidebarLogin,
    PreCheckoutSidebarRegister,
    PreCheckoutSidebarGuest
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    const isModalOpen = urlParams.get('pre-checkout-sidebar-open')
    if (isModalOpen === 'true') {
      this.openModal()
    }

    if (this.error) {
      this.currentViewError = this.error
    }
  },
  computed: {
    ...mapGetters([
      'cartProductsTotal'
    ]),
    loginVisible () {
      return this.currentView === 'login'
    },
    registerVisible () {
      return this.currentView === 'register'
    },
    guestVisible () {
      return this.currentView === 'guest'
    },
    hasError () {
      return !!this.currentViewError
    },
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    cartItemsToggleImage () {
      return this.cartItemsVisible ? '/ui/main/img/toggle_arrow_up.svg' : '/ui/main/img/toggle_arrow_down.svg'
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    openModal () {
      this.$refs.preCheckoutSidebarModal.$emit('modal-open')
    },
    onRegisterClick () {
      this.currentViewError = ''
      this.currentView = 'register'
    },
    onGuestClick () {
      this.currentViewError = ''
      this.currentView = 'guest'
    },
    onReturnBackClick () {
      this.currentViewError = ''
      this.currentView = 'login'
    },
    cartItemsToggle () {
      this.cartItemsVisible = !this.cartItemsVisible
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .cp-utilities-generic_modal {
//   top: 108px;
//   height:calc(100vh - 108px)!important;
//   @media screen and (max-width: 1199px) {
//     top: 55px;
//     padding-top:30px;
//     max-width: 505px!important;;
//     height:calc(100vh - 55px)!important
//   }
//   @media screen and (max-width: 767px) {
//     align-items: flex-start!important;
//     top:65px;
//     height:calc(100vh - 65px)!important
//   }
// }
// ::v-deep .cp-utilities-generic_modal-wrapper {
//   z-index: 100;
//   &.open {
//     .cp-utilities-generic_modal-overlay {
//       background: rgba(34, 33, 33, 0.4);
//       display: none;
//     }
//   }
// }
// ::v-deep .cp-utilities-generic_modal {
//   padding: 0 !important;
//   right: 0;
// }
.pre-checkout-sidebar-header {
  display: grid;
  justify-items: center;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-bottom: 1rem;
}
.pre-checkout-sidebar-header-error {
  padding: 10px;
  background: #ECCCCC;
  color: #D94444;
  font-size: 12px;
  box-shadow: 0 3px 6px #00000029;
}

  //custom override styles for heals
  ::v-deep .cp-utilities-generic_modal{
    position: relative!important;
    width: 100%!important;
    height: 100%!important;
    max-height: none!important;
    max-width: fit-content!important;
    padding: 0!important;
    overflow: unset!important
  }

</style>
